var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowShortLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 20,
    viewBox: "0 0 12 20",
    fill: "#F9F8F0",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.37182 0.383314C2.1135 0.135286 1.78474 0 1.39726 0C0.62231 0 0 0.586245 0 1.33033C0 1.70237 0.164384 2.04059 0.434443 2.29989L8.65362 10.0113L0.434443 17.7001C0.164384 17.9594 0 18.3089 0 18.6697C0 19.4138 0.62231 20 1.39726 20C1.78474 20 2.1135 19.8647 2.37182 19.6167L11.5068 11.0485C11.8356 10.7554 11.9883 10.3946 12 10C12 9.60541 11.8356 9.26719 11.5068 8.9628L2.37182 0.383314Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowShortLight);
export default __webpack_public_path__ + "static/media/arrow_short_light.1a414c80ef72d7e686a2985d5db493bc.svg";
export { ForwardRef as ReactComponent };